import React, { Component } from 'react'
import { Icon } from 'semantic-ui-react'
import { VideoPlayer } from '~/common/videoPlayer'

export default class MaterialPreview extends Component {
  state = {
    open: false,
  }

  renderImagePreview = file => {
    return (
      <div className="material-preview-item material-preview-item--image">
        <img src={file.get('url')} />
      </div>
    )
  }

  renderVideoPreview = file => {
    return (
      <div className="material-preview-item material-preview-item--video">
        <VideoPlayer src={file.get('url')} autoplay />
      </div>
    )
  }

  render() {
    let { open } = this.state
    let { file, type } = this.props

    if (type !== 'video' && type !== 'image') return null

    return (
      <span className="material-preview">
        <button className="material-preview-button" onClick={e => e.preventDefault() & this.setState({ open: true })}>
          <Icon name="eye" />
          Esikatsele
        </button>
        {open && (
          <div className="material-preview-modal">
            <div
              className="material-preview-modal-overlay"
              onClick={e => e.preventDefault() & this.setState({ open: false })}
            />
            <div className="material-preview-modal-content">
              {type === 'image' ? this.renderImagePreview(file) : this.renderVideoPreview(file)}
            </div>
          </div>
        )}
      </span>
    )
  }
}
